import { composeIO } from 'react-compose-io'
import { tiposDeLancamentosIO } from './TiposDeLancamentos.IO'
import { TiposDeLancamentosView } from './TiposDeLancamentos.View'

export const TiposDeLancamentos = composeIO(TiposDeLancamentosView, tiposDeLancamentosIO)
